<template>
  <nav class="navbar">
    <div class="container">
      <div class="brandContainer">
        <a class="brandLink" href="https://www.invers-gruppe.de/">
            <img class="brand" src="logo.svg" alt="invers" />
        </a>
      </div>
      <div id="menuIcon" class="navbarToggler"
        v-bind:class="[ this.expanded ? 'active' : null]" @click="handleClick()">
        <span class="iconBar"></span>
        <span class="iconBar"></span>
        <span class="iconBar"></span>
      </div>
      <div class="navbarLinks" 
        v-bind:class="[this.expanded ? null : 'collapsed']">
        <ul>
          <li id="homeNav"><a href="https://www.invers-gruppe.de/">Start</a></li>
          <!-- <li id="veranstaltungenNav" class="dropdown_li" onclick="dropbtnFunktion()">
                            <a href="#" >Veranstaltungen  <i class="fa fa-caret-down"></i></a>
                            <div id="Veranstaltung_dropdown" class="Veranstaltung_dropdown_content" >
                                <a class="Ver_dropdown_a" href="https://www.invers-gruppe.de/veranstaltungen/investment-tour-23/">Investment Tour 2023</a>
                                <a class="Ver_dropdown_a" href="https://www.invers-gruppe.de/veranstaltungen/roadshow-2023/">Roadshow</a>
                                 <a class="Ver_dropdown_a" href="https://www.invers-gruppe.de/veranstaltungen/maklerfruehstuecke-2023/">Maklerfrühstücke</a> 
                            </div>
                        </li> -->
          <li id="inversNav"><a href="https://www.invers-gruppe.de/invers.php">Invers Gruppe</a></li>
          <li id="supportNav"><a href="https://www.invers-gruppe.de/support.php">Unterstützung</a></li>
          <li id="betreuungNav"><a href="https://www.invers-gruppe.de/betreuung.php">Betreuung</a></li>
          <li id="teamNav"><a href="https://www.invers-gruppe.de/team/">Team</a></li>
          <li id="jobsNav" ><a href="https://www.invers-gruppe.de/jobs/">Jobs</a></li>
          <li id="kontaktNav"><a href="https://www.invers-gruppe.de/kontakt.php">Kontakt</a></li>
          <li><a href="https://secure.invers-gruppe.de/login.html" target="_blank">Login</a></li>
        </ul>
      </div>
    </div>
  </nav> 
</template>

<script>
export default ({
  data: () => ({
     expanded: false,
  }),
  methods: {
    handleClick: function () {
    this.expanded = !this.expanded
    }
    //$("#teamNav").addClass("active");
  }
})
</script>

<style scoped>
.navbar {
    display: flex;
    flex-wrap: wrap;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(255,255,255) ;
    padding: 0;
    color:  rgba(0,0,0);
    min-height: 50px;
    z-index: 999;
    font-weight: 400;
    box-shadow: 0px 2px 13px -4px rgba(0,0,0,0.69);
    transition: ease all .6s;
}
.navbar::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255,255,255,0.62);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
  z-index: -1;
}
.container{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-top: 0;
  padding-bottom:0;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.brandContainer {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.brand {
    height:25px;
    margin-left: 21px
}
.brandLink{
  text-decoration: none;
  border: none;
}
.navbarLinks ul {
    margin: 0;
    padding: 0;
    display: flex;
}

.navbarLinks li {
    list-style: none;
}

.navbarLinks li a {
     border-bottom: none;
    text-decoration: none;
    font-size: 14px;
    color: rgba(0,0,0,0.72);
    padding: 15px;
    display: block;
}

.active {
    color: rgba(0,0,0) !important;
}

.navbarLinks li a:hover {
  border-bottom: none;
    color: rgba(0,0,0)
}


/***neu dazu**/
/*Burger-Menu Animation*/
.navbarToggler {
    display: none;
    border: none;
    background: transparent !important;
    align-items: center;
    margin: 15px;
    cursor: pointer;
  }
  
  .navbarToggler:focus {
    outline: none;
    background: transparent !important;
  }
  
  .navbarToggler .iconBar {
    background-color: rgba(0,0,0,0.72);
    transform: rotate(0deg) translate(0px, 0px);
    transition: ease all .2s;
  }
  
  .navbarToggler .iconBar {
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 1px;
  }
  
  .navbarToggler .iconBar+.iconBar {
    margin-top: 4px;
  }
  
  .iconBar:nth-child(2) {
    width: 16px;
    transition: ease all .2s;
  }
  
  .navbarToggler:hover>.iconBar:nth-child(2) {
    width: 22px;
    transition: ease all .2s;
  }
  
  .navbarToggler:active>.iconBar:nth-child(2) {
    width: 22px;
    transition: ease all .2s;
  }
  
  .navbarToggler.active .iconBar:nth-child(1) {
    transform: rotate(45deg) translate(5px, 4px);
    transition: ease all .2s;
  }
  
  .navbarToggler.active .iconBar:nth-child(2) {
    opacity: 0;
    transition: ease all .2s;
  }
  
  .navbarToggler.active .iconBar:nth-child(3) {
    transform: rotate(-45deg) translate(4px, -4px);
    transition: ease all .2s;
  }
  
  /*END Burger-Menu Animation*/

@media(max-width: 1265px) {
    .navbarToggler {
        display: block;
    }

    .bar:nth-child(2) {
        width: 16px;
        transition: ease all .2s;
      }

    .toggleButton:hover>.bar:nth-child(2) {
        width: 22px;
        transition: ease all .2s;
    }
      
    .navbarLinks {
        display: flex;
        width: 100%;
        position: absolute;
        left: 0;
        top:50px;
        opacity: 0.98;
        transition: 0.3s ease-in-out;
        background-color:#fff;
    }

    .navbar {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .navbarLinks ul {
        width: 100%;
        margin: 0 50px;
        flex-direction: column;
        min-height: calc(100vh - 50px);
    }
    .navbarLinks li a {
        padding: .5rem 1rem
    }

    .navbarLinks.collapsed {
        position: absolute;
        left: -100%;
        opacity: 0;
    }

    .navbarLinks>ul>li>a {
        padding:0;
        line-height: 48px;
        font-size: 15px;
      }
    
      .navbarLinks>ul>li:first-child a{
        padding-top: 17px;
      }
    
      .navbarLinks>ul>li:not(:first-child) a{
        border-top: 1px solid rgba(214,214,214,0.5);
        /*line-height: 47px;*/
      }

}
/****Navbar Dropdown*****/

.Veranstaltung_dropdown_content {
	display: none;
	position: absolute;
	background-color: #f9f9f9;
	min-width: 160px;
	box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
	z-index: 200;
  }
  .Veranstaltung_dropdown_content:hover{
	cursor: pointer;
  }
  
.Veranstaltung_dropdown_content a {
	color: black;
	text-decoration: none;
	display: block;
	padding: 5px;
	text-align: left;
  }
  .Veranstaltung_dropdown_content a:hover {
	background-color: #ddd;
  }
.dropdown_li:hover .Veranstaltung_dropdown_content{
	display: block;
}
.Ver_dropdown_a{
	padding:10px;
}
.menuDropdownshow{
	display: block;
}
/****Navbar Dropdown Ende*****/
</style>